import { cn } from '@/slw/shared/lib/utils';

type HeadingTitleContentProps = {
  title: string;
  className?: string;
};

export function HeadingTitleContent(props: HeadingTitleContentProps) {
  return (
    <div className={cn('text-[1.5rem] md:text-[2.5rem] lg:text-[2.5rem] font-bold mb-4 md:mb-7', props.className)}>
      {props.title}
    </div>
  );
}
